<template>
  <router-view></router-view>
</template>

<script>
import { ABILITY_TOKEN } from '@casl/vue';
import { fetchPermissions, fetchOUAccess } from '@/helpers/abilities.js';
import { cachedGet } from '@/helpers/axios';
import { applyCachedSystemConfiguration, getSystemConfiguration } from '@/services/systemConfigurationService';

export default {
  name: 'App',
  inject: {
    $ability: { from: ABILITY_TOKEN },
  },
  components: {},
  methods: {
    loadPermissions() {
      if (localStorage.getItem('jwt')) {
        let permissions = localStorage.getItem('permissions')
          ? JSON.parse(localStorage.getItem('permissions'))
          : [];
        if (
          permissions == undefined ||
          permissions == null ||
          permissions.length == 0
        ) {
          fetchPermissions();
        }
      }
    },
    loadOUAccess() {
      if (localStorage.getItem('jwt')) {
        let ouAccess = localStorage.getItem('ouAccess')
          ? JSON.parse(localStorage.getItem('ouAccess'))
          : [];
        if (ouAccess == undefined || ouAccess == null || ouAccess.length == 0) {
          fetchOUAccess();
        }
      }
    },
    async checkTokenExpired() {
      if (localStorage.getItem('jwt')) {

        const userId = localStorage.getItem('userid');
        if (userId) {
          await cachedGet(`${process.env.VUE_APP_AUTHDOMAIN}/api/v1/me`, {}, 15 * 1000)
            .then((data) => {
              if (!data.data) {
                this.logout();
              } else {
                localStorage.setItem('user', JSON.stringify(data.data));
              }
            })
            .catch(() => {
              this.logout();
            });
        }
      }
    },
    logout() {
      localStorage.clear();
      this.$router.push({ name: 'login' });
    },

  },
  computed: {
    rules() {
      return this.$store.state.rules || [];
    },
  },
  created() {
    this.$store.commit('getPermissions');
    this.$store.commit('getRules');
    this.$ability.update(this.rules);
  },
  mounted() {
    applyCachedSystemConfiguration();
    // Skip permissions/OU loading and token check on public pages (no hardcoded routes)
    const authRequired = this.$route.matched.some((r) => r.meta?.authRequired);
    if (!authRequired) return;

    this.loadPermissions();
    this.loadOUAccess();
    getSystemConfiguration().catch(() => {
      // Cached configuration remains active while the authoritative request is unavailable.
    });

    // Validate token on app mount — if expired, the global axios 401
    // interceptor will redirect to the login page automatically.
    setTimeout(() => {
      this.checkTokenExpired();
    }, 1000);
  },
};
</script>
